module.exports = __webpack_public_path__ + "media/ambrascet_m.555aafa8.mp3";